import { fetchAllPostPromisedData } from "../../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../../common/constant";

export const getManualParentConsentForm = async (templateData) => {
    try {

        const reqObj = {
            templateName: 'manualParentConsentForm',
            getPdf: true,
            templateData
        }

        return await fetchAllPostPromisedData(endpoint.createPdf, reqObj);
    } catch (err) {
        console.error(err);
    }

}